import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams, Navigate, useLocation } from "react-router-dom";
import Unauthorized from "components/logout/Unauthorized";
import hasRouteAccess from "utils/accessControl";
import { isLoginAuth } from "utils/login";
import { lStorage } from "utils/storage";

import PropTypes from "prop-types";
import { isWebsiteUnderMaintenance } from "utils/common";

function AuthGuard({ component: Component, path }) {
  const [qParam] = useSearchParams();
  const location = useLocation();
  const [underMaintenance, setUnderMaintenance] = useState(false);
  useEffect(() => {
    isWebsiteUnderMaintenance().then((res) => setUnderMaintenance(res));
  }, []);

  useEffect(() => {
    if (underMaintenance) {
      import("hfn-maintenance-web/main");
    }
  }, [underMaintenance]);
  if (
    qParam.get("minimalmode") &&
    qParam.get("template") &&
    qParam.get("sector") &&
    qParam.get("category")
  ) {
    const minimalMode = {
      minimalmode: qParam.get("minimalmode"),
      event: qParam.get("event"),
      sessionCount: qParam.get("sessionCount"),
      authredirect: qParam.get("authredirect"),
      template: qParam.get("template"),
      sector: qParam.get("sector"),
      sectorName: qParam.get("sectorName"),
      category: qParam.get("category"),
      city: qParam.get("city"),
      trainer: qParam.get("trainer"),
    };
    lStorage.set("minimalMode", minimalMode);
  }
  const isLoggedIn = useMemo(() => isLoginAuth(), []);
  const hasAccess = useMemo(() => hasRouteAccess(path), [path]);
  if (!isLoggedIn) lStorage.set("landingPage", { param: location });
  else lStorage.set("landingPage", {});
  return underMaintenance ? (
    <hfn-maintenance-web />
  ) : (
    <div>
      {isLoggedIn ? (
        <> {hasAccess ? <Component /> : <Unauthorized />} </>
      ) : (
        <Navigate to={{ pathname: "/login" }} />
      )}
    </div>
  );
}

AuthGuard.propTypes = {
  component: PropTypes.elementType.isRequired,
  path: PropTypes.string.isRequired,
};
export default AuthGuard;
